var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "mode-page" }, [
    _c("header", { staticClass: "top" }, [
      _c("div", { staticClass: "top-glow" }),
      _vm._v(" "),
      _c("div", { staticClass: "tabs" }, [
        _c("span", { staticClass: "tab active" }, [_vm._v("联网模式")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "tab",
            on: {
              click: function($event) {
                return _vm.$router.push({
                  name: "devicelocal",
                  query: { iccid: _vm.imei }
                })
              }
            }
          },
          [_vm._v("本地模式")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "status-card card" }, [
      _c("div", { staticClass: "status-item" }, [
        _c("img", {
          attrs: {
            src: require("./static/images/service-mode/Frame-1.png"),
            alt: ""
          }
        }),
        _c("span", [_vm._v("电量" + _vm._s(_vm.deviceInfo.battery || 0) + "%")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "status-item" }, [
        _c("img", {
          attrs: {
            src: require("./static/images/service-mode/Frame.png"),
            alt: ""
          }
        }),
        _c("span", [
          _vm._v("设备连接 " + _vm._s(_vm.deviceInfo.client_number || 0))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "status-item" }, [
        _c("img", {
          attrs: {
            src: require("./static/images/service-mode/Frame-2.png"),
            alt: ""
          }
        }),
        _c("span", [_vm._v(_vm._s(_vm.deviceInfo.isonline ? "在线" : "离线"))])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "block" }, [
      _c("h2", [_vm._v("设备设置")]),
      _vm._v(" "),
      _c("div", { staticClass: "card setting-card" }, [
        _c("div", { staticClass: "row row-input" }, [
          _c("span", [_vm._v("WiFi名称：")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editSsid.ssid,
                expression: "editSsid.ssid"
              }
            ],
            staticClass: "wifi-input",
            attrs: { type: "text", placeholder: _vm.deviceInfo.ssid },
            domProps: { value: _vm.editSsid.ssid },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.editSsid, "ssid", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row row-input" }, [
          _c("span", [_vm._v("WiFi密码：")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editSsid.key,
                expression: "editSsid.key"
              }
            ],
            staticClass: "wifi-input",
            attrs: { type: "text", placeholder: _vm.deviceInfo.key },
            domProps: { value: _vm.editSsid.key },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.editSsid, "key", $event.target.value)
              }
            }
          }),
          _c("button", { on: { click: _vm.saveSsid } }, [_vm._v("保存")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("设备重启")]),
          _c("button", { on: { click: _vm.restart } }, [_vm._v("重启")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("设备恢复出厂设置")]),
          _c("button", { on: { click: _vm.reset } }, [_vm._v("重置")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "block" }, [
      _c("h2", [_vm._v("网络切换")]),
      _vm._v(" "),
      _c("div", { staticClass: "card net-card" }, [
        _c(
          "button",
          {
            staticClass: "net-btn",
            class: { active: _vm.deviceInfo.simIndex === 0 },
            on: {
              click: function($event) {
                return _vm.qieka(0)
              }
            }
          },
          [_vm._v("中国电信")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "net-btn",
            class: { active: _vm.deviceInfo.simIndex === 2 },
            on: {
              click: function($event) {
                return _vm.qieka(2)
              }
            }
          },
          [_vm._v("中国移动")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "net-btn",
            class: { active: _vm.deviceInfo.simIndex === 99 },
            on: {
              click: function($event) {
                return _vm.qieka(99)
              }
            }
          },
          [_vm._v("智能选网")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "block" }, [
      _c("h2", [_vm._v("设备信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "card info-card" }, [
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("卡号：")]),
          _c("span", [_vm._v(_vm._s(_vm.deviceInfo.iccid))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("信号强度：")]),
          _c("span", [_vm._v(_vm._s(_vm.deviceInfo.rsrp) + "dbm 良好")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("imei码：")]),
          _c("span", [_vm._v(_vm._s(_vm.deviceInfo.imei))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("sn：")]),
          _c("span", [_vm._v(_vm._s(_vm.deviceInfo.sn))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02e6b94f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e6b94f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/device.vue
// module id = null
// module chunks = 